import React from "react";
import { CircularProgress } from "@mui/material";
import styles from "../styles.module.scss";
import { TeamChatContainer } from "./TeamChatContainer";
import { useTeamPageContext } from "./TeamPageContext";
import { useNavigate } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";

export const ChatPage: React.FC = () => {
	const navigate = useNavigate();
	const { workspace, selectedTeam, members, teamNotFound } = useTeamPageContext();

	const handleToBackPage = () => {
		navigate("..");
	};

	return (
		<div className={styles.chatPanel}>
			{/* Chat header */}
			<header className={styles.chatHeader}>
				<button
					className={styles.chatHeaderBackButton}
					onClick={handleToBackPage}
				>
					<Icon
						path={mdiChevronLeft}
						size={1}
					/>
				</button>
				<div className={styles.chatHeaderInfo}>
					<div className={styles.chatHeaderAvatar}>{selectedTeam?.name?.charAt(0).toUpperCase() || "T"}</div>
					<div>
						<h2 className={styles.chatHeaderName}>{selectedTeam?.name || "Selecionar Equipe"}</h2>
					</div>
				</div>
			</header>

			{selectedTeam && workspace ? (
				<TeamChatContainer
					workspaceId={String(workspace.id)}
					workspaceInternalId={workspace.id}
					team={selectedTeam}
					members={members}
				/>
			) : (
				<div className={styles.loadingState}>
					<CircularProgress
						color="inherit"
						size={24}
					/>
					<span>{teamNotFound ? "Equipe não encontrada." : "Carregando equipe..."}</span>
				</div>
			)}
		</div>
	);
};
